import { Environment } from './types';

export const firebaseApiKey = 'AIzaSyC7MK2yLgb4ZN0tlGwACizM81nYfGtI5lE';
export const stripeSeSKey = 'pk_test_lZzqRcUC3rEqYYfdWJ0w62S2';
export const rollbarToken = '9631bf98995142d2a35e9094336ebd13';

/* tslint:disable */
export const environment: Environment = {
  production: false,
  localLogin: false,
  name: 'demo',
  products: {
    chatbot: 'https://app-test.ideta.io',
    privateReplies: 'https://private-replies-test.ideta.io',
    webhooks: 'https://webhooks-test.ideta.io',
    livechat: 'https://livechat-test.ideta.io',
    inbox: 'https://inbox-test.ideta.io',
    linkedIn: 'https://linkedin.ideta.io/',
    sentimentAnalysis: 'https://api-portal.ideta.io/catalog/prd_t83al06y66emm5k5',
    workflowAnalysis: 'https://api-portal.ideta.io/catalog/prd_hzusd8o2g4sy10d4'
  },
  logos: {
    chatbot: 'assets/img/chatbot.svg',
    privateReplies: 'assets/img/autocomment.png',
    webhooks: 'assets/img/webhooks.svg',
    livechat: 'assets/img/livechat.svg',
    inbox: 'assets/img/inbox.svg',
    linkedIn: 'assets/img/linkedIn_ai.png',
    sentimentAnalysis: 'assets/img/sentiment-analysis.png',
    workflowAnalysis: 'assets/img/workflow-analysis.png'
  },
  domain: 'https://connect-test.ideta.io',
  backendUrl: 'https://api-test.ideta.io',
  firebase: {
    authDomain: 'app-test.ideta.io',
    databaseURL: 'https://trhs-sandbox1.firebaseio.com',
    projectId: 'trhs-sandbox1',
    storageBucket: 'trhs-sandbox1.appspot.com',
    messagingSenderId: '1059659963313'
  },
  facebook: {
    appId: '291291871593091',
    xfbml: true,
    version: 'v13.0',
    cookie: true,
    scopes: ['public_profile', 'email', 'pages_messaging', 'pages_show_list', 'pages_manage_metadata', 'pages_read_engagement']
  },
  instagram: {
    scopes: [
      'public_profile',
      'email',
      'pages_messaging',
      'pages_show_list',
      'pages_manage_metadata',
      'pages_read_engagement',
      'instagram_basic',
      'instagram_manage_messages',
      'pages_show_list'
    ]
  },
  rollbar: {
    active: true,
    buildVersion: 'ca51c5f62a'
  },
  defaults: {
    user: {
      avatarUrl: 'assets/img/avatar.svg'
    }
  },
  appSettings: {
    minWidth: 374
  }
};
/* tslint:enable */
